import { useState, useEffect } from 'react';
import { useSupabaseStore } from './supabaseStore';
import logger from '@/logger';

export const useOrganizationId = (authLoading: boolean) => {
	const supabase = useSupabaseStore((state) => state.supabase);
	const [organizationId, setOrganizationId] = useState<string | null>(null);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		if (authLoading) return;

		const getOrganizationId = async () => {
			setIsLoading(true);
			try {
				const { data: orgData, error: orgError } = await supabase
					.from('whatsapp_organizations')
					.select('id')
					.eq('organization_name', 'Finclu')
					.single();

				if (orgError) {
					console.error('Error fetching organization_id:', orgError);
					logger.error('Error fetching organization_id:', orgError);

					const { data: allOrgs, error: allOrgsError } = await supabase
						.from('whatsapp_organizations')
						.select('id')
						.eq('organization_name', 'Finclu')
						.limit(1);

					if (!allOrgsError && allOrgs && allOrgs.length > 0) {
						console.log('Found organization:', allOrgs);
						const orgId = allOrgs[0]?.id;
						if (orgId) {
							setOrganizationId(orgId);
						}
					}
					setIsLoading(false);
					return;
				}

				console.log('Organization data:', orgData);

				if (orgData?.id) {
					console.log('Setting organization_id:', orgData.id);
					setOrganizationId(orgData.id);
				} else {
					console.log('No organization_id in orgData');
				}
			} catch (err) {
				logger.error('Error getting organization_id:', err);
			} finally {
				setIsLoading(false);
			}
		};

		getOrganizationId();
	}, [authLoading, supabase]);

	return { organizationId, isLoading };
};
